import { throttleTime } from "rxjs/operators";
import { Component } from "@angular/core";
import { WindowsNotificationService } from "../../../services/windows-notification.service";
import { ReportsService } from "../../../services/reports.service";
import { UserService } from "../../../domain/user-service";
import moment from "moment";
import { ShowRepository } from "../../../domain/show-repository";

@Component({
  selector: "gaps-report",
  templateUrl: "./gaps-report.component.html",
  styleUrls: ["./gaps-report.component.scss"],
})
export class GapsReportComponent {
  rows = [];
  selected = [];
  columns = [
    { name: "Short Date", prop: "gapShortDate" },
    { name: "From Time", prop: "gapFromTime" },
    { name: "To Time", prop: "gapToTime" },
    { name: "Duration", prop: "gapDuration" },
  ];
  showPreloader: boolean = true;

  constructor(
    private windowsNotificationService: WindowsNotificationService,
    private reportsService: ReportsService,
    private userService: UserService,
    private showApi: ShowRepository,
  ) {
    windowsNotificationService.ACTIONS.showGapReport.subscribe(() => {
      this.loadGapsReport();

      console.log("refreshing the report");

      let listenToGapsAlerts = this.reportsService.reportsGlobalState
        .pipe(throttleTime(3000))
        //.debounceTime(3000)
        .subscribe(() => {
          this.loadGapsReport();
        });

      //clean up listeners
      windowsNotificationService.ACTIONS.closeGapReport
        .subscribe(() => {
          listenToGapsAlerts.unsubscribe();
        })
        .unsubscribe();
    });
  }

  loadGapsReport() {
    this.showPreloader = true;
    this.selected = [];
    this.userService.getCurrentChannel().then(({ id }) => {
      this.reportsService.getGapsReport(id).then((report) => {
        this.rows = this.mapDtos(report);
        this.showPreloader = false;
      });
    });
  }

  clickOnCloseBtnHandler() {
    this.windowsNotificationService.ACTIONS.closeGapReport.next(true);
  }

  onSelect({ selected }) {
    console.log("Select Event", selected, this.selected);

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }
  onActivate(event) {
    //console.log('Activate Event', event);
  }
  checkSelectable(event) {
    console.log("Checking if selectable", event);
    //return false;
  }

  closeGaps() {
    console.log("close gaps clicked", this.selected);
    console.log(this.selected.map((item) => item.refToShowBeforeGap));
    this.showPreloader = true;

    let selectedGapIds: any = this.selected.map(
      (item) => item.refToShowBeforeGap,
    );

    this.showApi.closeGaps(selectedGapIds).then((result) => {
      console.log(result);
      console.log(
        this.rows.filter(
          (item) => selectedGapIds.includes(item.refToShowBeforeGap) == false,
        ),
      );

      //this.rows = this.rows.filter(item => selectedGapIds.includes(item.refToShowBeforeGap) == false);
      this.selected = [];

      this.showPreloader = false;
    });
  }

  private mapDtos(report: Array<any>) {
    return report.map((entry) => {
      let shortDate = moment(moment.utc(entry.gapFromTime).valueOf()).format(
        "DD-MM-YYYY",
      );
      let fromTime = moment(moment.utc(entry.gapFromTime).valueOf()).format(
        "HH:mm:ss.SSSS",
      );
      let toTime = moment(moment.utc(entry.gapToTime).valueOf()).format(
        "HH:mm:ss.SSSS",
      );

      let dto: any = { ...entry };

      dto.gapShortDate = shortDate;
      dto.gapToTime = toTime;
      dto.gapFromTime = fromTime;
      dto.goToGapTicks = moment.utc(entry.gapFromTime).valueOf();

      return dto;
    });
  }
}
